import React, { useRef } from 'react'
import { ButtonBar, Button } from './button/button'
import { IconCheck, IconCopy } from '../../../../../../../../shared/icon/icon'
import { useCopy } from '../../../../../../../../shared/clipboard/clipboard'

export const Result = ({ value }) => {
  // Copied inside the click (shared/clipboard), so Safari allows it; the
  // check only after a real copy, otherwise the result is selected.
  const copy = useCopy()
  const text = useRef(null)
  const handleClick = () => copy.copy(value, text)

  return (
    <div>
      <ButtonBar>
        <Button Icon={copy.copied ? IconCheck : IconCopy} onClick={handleClick} />
        {copy.manual && <span className="small text-muted align-self-center" role="status">{copy.hint}</span>}
      </ButtonBar>
      <div className="border-top border-bottom p-3" ref={text}>
        {value}
      </div>
    </div>
  )
}
